// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"571":"7a57b210","747":"edbf249e"}[chunkId] + ".chunk.js";
};